import Error from '@paybis/frontend-common-lib/src/components/error.vue';
import VueRouter from 'vue-router';

const router = new VueRouter({
  routes: [
    { path: '/error', name: 'error', component: Error },
  ],
  mode: 'abstract',
});

export default router;

